export default __webpack_public_path__ + "static/media/caret-right.4a9b4237.svg";